/**
 * Whether sounds are written down as well as played.
 *
 * Off by default, and that is not a judgement about who needs it. A caption is a line of text over
 * the picture, and a player who can hear the raider shout is a player the line is covering the
 * world for. Everything else in this repo defaults to what most players want; this defaults off for
 * exactly that reason and is one switch away for everybody it is the difference for.
 *
 * Read per tick by the overlay, the way the HUD frame reads its own skin and size, so a player who
 * turns it on from a paused game sees the next thing anybody says.
 */

export const DEFAULT_AUDIO_CAPTIONS = false;

let captioned = DEFAULT_AUDIO_CAPTIONS;

export function audioCaptions(): boolean {
  return captioned;
}

export function setAudioCaptions(on: boolean): void {
  captioned = on;
}
